export default __webpack_public_path__ + "static/Iphone_beta-3c02c795eb508992963d735490bb4b46.png";